import { defineMessages } from 'react-intl';

export const promoMessages = defineMessages({
    promoTermsAndConditions: {
        id: 'promo.termsAndConditions',
        description: 'Promo terms and conditions text',
        defaultMessage: 'Terms and conditions'
    },

    promoOfferEndDate: {
        id: 'promo.promoOfferEndDate',
        description: 'Promotion offer end date',
        defaultMessage: 'Offer valid through {endDate} EST'
    },

    promoDisplaySoldOut: {
        id: 'promo.displaySoldOut',
        description: 'Promotion Sold Out message',
        defaultMessage: 'SOLD OUT : '
    }
});
